import React, { useState, useRef, useEffect, useContext } from "react";
import HomeScreenBGItemScreen from "./HomeScreenBGItemScreen";  
import VideoPlayer from "../../components/videoPlayer/videoPlayer";
import LoaderScreen from "../../components/LoaderScreen";
import ModalScreen from "../../components/ModalScreen";
import loginimg from "../../assets/loginimg.png";
import rent from "../../assets/Rent.png";
import AudioPlayer from "../../components/AudioPlayer";
import ErrorScreen from "../../components/ErrorScreen";
import errorIcon from "../../assets/NoSearchResultFound1.png";
import {
  createDrmLicenseV2,
  getContentDetails,
  getContentPlaybackInfo,
  getVideoUrlV2,
} from "../../services/services";
import logoutIcon from "../../assets/Logout-Icon.png";
import AuthFailModal from "../../components/AuthFailModal";
import { AppContext } from "../../AppContext";
import { sendMatomo, sendSimilarThisEvent } from "../../Analytics/MatomoManager/detailMatomoMedia";


let resolution = window.RESOLUTION;
let dataWrapper = [];
let itmDetails = [];

const HomeDetailsScreen = ({
  handleBack,
  firstTag,
  data,
  isLogedIn,
  shouldAuthError,
  isLiveEvent,
  isLiveScreen = false,
  detailToDetail,
  selectedTag,
  premiumQr
  // isError = false,
}) => {
  const [screen, setScreen] = useState("HomeDetailsScreen");
  const [updateData, setUpdateData] = useState(data);
  const { sourceContext, setSourceContext } = useContext(AppContext);
  const [shouldFocusToScreenBG, setShouldFocusToScreenBG] = useState(true);
  const { isAppInAppData, setIsAppInAppData } = useContext(AppContext);
  const [plansPrice, setPlansPrice] = useState(0);
  const [NoDataFound, setNoDataFound] = useState(false)
  const mountedRef = useRef(true);
  const hasFetchedDataRef = useRef(false);
  const isGridCalledRef = useRef(true);
  const timeoutRef = useRef(null);
  const [state, setState] = useState({
    shouldFocusToScreenBG: true,
    isLogedInUser: isLogedIn,
    loading: true,
    // itemDetails: [data],
    itemDetails: [],
    shouldShowError: false,
    shouldShowAuthModal: false,
    shouldRental: false,
    errTitle: "",
    errDescription: "",
    errIcon: "",
    iconWdth: "100px",
    iconHeight: "100px",
    button: ["Ok", "Cancel"],
    okaybtn: ["Okay"],
    shouldShowToast: false,
    toastMsg: "",
    toastBgColor: "#FF00FF",
    DRMToken: null,
    typ: "hls",
    DRMvdoSRC: null,
    DrmInformatin: null,
    GetVideoUrlData: null,
    GetVideoUrlData_audio: null,
    currentItemSeason: null,
    VideoDataDrm: null,
    shouldRemindPopup: false,
    isError: false,
  });

  const {
    isLogedInUser,
    loading,
    itemDetails,
    hasNextContent,
    season,
    episode,
    shouldShowError,
    shouldShowAuthModal,
    errTitle,
    errDescription,
    errIcon,
    iconWdth,
    iconHeight,
    button,
    shouldShowToast,
    toastMsg,
    toastBgColor,
    DRMToken,
    typ,
    DRMvdoSRC,
    DrmInformatin,
    GetVideoUrlData,
    GetVideoUrlData_audio,
    okaybtn,
    currentItemSeason,
    VideoDataDrm,
    shouldRemindPopup,
    isError,
    shouldRental,
  } = state;
  dataWrapper = [];
  dataWrapper.push(data);
  let ScreenComponent;
  let videodataResponse2;

  const navigateToScreen = (screenname,item) => {
    console.log("screenname...", screenname);
    setUpdateData(item);
    setScreen(screenname);
  };
  const modalOKButtonHandler = (action) => {
    switch (action) {
      case "Login":
        localStorage.removeItem("user_details");
        localStorage.removeItem("userId");
        localStorage.removeItem("profileId");
        localStorage.clear();
        window.appReload();
        navigateToScreen("LoginScreen");
        break;
      case "Ok":
        setState((prevState) => ({
          ...prevState,
          shouldShowError: false,
          shouldFocusToScreenBG: true,
        }));
        HomeScreenBGItemScreen.setFocus(true);
        break;

      case "Okay, Got it":
        console.log("okay")
        setState((prevState) => ({
          ...prevState,
          shouldRental: false,
          shouldFocusToScreenBG: true,   
        }));
        HomeScreenBGItemScreen.setFocus(true);
        break;
      default:
        break;
    }
  };
  const modalCANCELButtonHandler = () => {
    setState((prevState) => ({
      ...prevState,
      shouldShowError: false,
      shouldFocusToScreenBG: true,
    }));
    HomeScreenBGItemScreen.setFocus(true);
    HomeScreenBGItemScreen.ReseTfocus(1);
  };

  const remindPopup = () => {
    console.log("remindPopup...");
    setState((prevState) => ({
      ...prevState,
      shouldRemindPopup: false,
      shouldShowError: false,
      shouldRental: false,
      shouldFocusToScreenBG: true,
    }));
    HomeScreenBGItemScreen.setFocus(true);
    HomeScreenBGItemScreen.ReseTfocus(1);
  };

  const handleErr = (errTp) => {
    let errttile = "";
    let errDescription = "";
    let errIcon = "";
    let btn = [];
    let okbtn = [];
    if (errTp === "NOT-AUTHENTICATED") {
      errttile = "Login to Continue";
      errDescription = "LoginContinue";
      errIcon = loginimg;
      btn = ["Login", "Cancel"];
    } else if (errTp === "PLAYBACKURL-ERROR") {
      errttile = "Playback URL error!";
      errDescription = "Playback url can't be undefined or blank.";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "WATCHLISTADD-ERROR") {
      errttile = "Error!";
      errDescription = "WatchlistError";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "WATCHLISTADD-SUCCCESS") {
      errttile = "Success";
      errDescription = "WatchlistSuccess";
      errIcon = "../assets/errorIcon.png";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "RENTAL-MESSAGE") {

      console.log("RENTAL-MESSAGE", itemDetails[0]?.pricing?.mrp, itemDetails);
      errttile = { x: "RentAvailable", y: plansPrice };
      errDescription = "RentMsg";
      errIcon = `${rent}`;
      btn = ["Ok", "Cancel"];
    } else if (errTp === "SUBSCRIBE-MESSAGE") {
      errttile = "Subscribewatch";
      errDescription = "SubscribeMsg";
      errIcon = "";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "GAME-MESSAGE") {
      errttile = "GamePlay";
      errDescription = "PlayMsg";
      errIcon = "";
      btn = ["Ok", "Cancel"];
    } else if (errTp === "AUTH-ERROR") {

      // errttile = "Session-Expired";
      errDescription = "session-desc";
      errIcon = `${logoutIcon}`;
      btn = ["Login"];
    } else if (errTp === "GET-REMINDER") {
      console.log(
        "shouldshowError.....",
        shouldShowError,
        shouldRemindPopup,
        errTp
      );
      errttile = "Login to Continue";
      errDescription = "LoginContinue";
      errIcon = loginimg;
      btn = ["Login", "Cancel"];
    }
    console.log("Hello", errTp)
    if (errTp === "AUTH-ERROR") {
      console.log("Session Expired", errttile, errDescription, errIcon);

      setState((prevState) => ({
        ...prevState,
        shouldShowError: false,
        shouldRental: false,
        shouldShowAuthModal: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: errIcon,
        button: btn,
        okaybtn: "Login to Continue",
      }));
    } else if (errTp === "RENTAL-MESSAGE") {
      errttile = { x: "RentAvailable", y: plansPrice };
      errDescription = "RentMsg";
      errIcon = `${rent}`;
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));




    } else if (errTp === "GAME-MESSAGE") {
      errttile = "GamePlay";
      errDescription = "PlayMsg";
      errIcon = "";
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));


    }
    else if (errTp === "SUBSCRIBE-MESSAGE") {
      errttile = "Subscribewatch";
      errDescription = "SubscribeMsg";
      errIcon = "";
      btn = ["Okay, Got it", "Cancel"];
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: false,
        shouldShowError: false,
        shouldShowAuthModal: false,
        shouldRental: true,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: "",
        button: btn,

      }));


    } else {
      setState((prevState) => ({
        ...prevState,
        shouldRemindPopup: errTp === "GET-REMINDER" ? true : false,
        shouldShowError: errTp !== "GET-REMINDER" ? true : false,
        shouldShowAuthModal: false,
        shouldRental: false,
        errTitle: errttile,
        errDescription: errDescription,
        errIcon: errIcon,
        button: btn,
        okaybtn: okbtn,
      }));
    }
  };

  const callBack = async (screenName) => {

    // Checking is this appinapp data
    const isAppInApp = isAppInAppData;

    if (isAppInApp) {
      setSourceContext(isAppInApp);
      setIsAppInAppData("");
      handleBack(screenName);
    } else if (selectedTag) {
      setSourceContext(`Home/Tag(${selectedTag?.id}/${selectedTag?.title})`);
      handleBack(screenName);
    } else {
      handleBack(screenName);
    }
  };

  console.log("itemDetailsData", data,itemDetails);
  const updateNextEpisodeObject = (itemDetailsData, seasonId, episodeId) => {
    let seasonObj = null;
    let episodeObj = null;
    let hasNextContent = false;
    let currentItemSeason = episodeId;

    for (
      let seasonIndex = 0;
      seasonIndex < itemDetailsData.season.length;
      seasonIndex++
    ) {
      const season = itemDetailsData.season[seasonIndex];
      if (season.id === seasonId) {
        for (
          let videoIndex = 0;
          videoIndex < season.videos.length;
          videoIndex++
        ) {
          if (season.videos[videoIndex].id === episodeId) {
            if (videoIndex + 1 < season.videos.length) {
              seasonObj = season;
              episodeObj = season.videos[videoIndex + 1];
              hasNextContent = true;
            } else if (seasonIndex + 1 < itemDetailsData.season.length) {
              seasonObj = itemDetailsData.season[seasonIndex + 1];
              episodeObj = seasonObj.videos[0];
              hasNextContent = true;
            } else {
              console.info(`No next episode/seasons`);
            }
            break;
          }
        }
        if (episodeObj) break;
        else hasNextContent = false;
      }
    }
    setState((prevState) => ({
      ...prevState,
      hasNextContent,
      season: seasonObj,
      episode: episodeObj,
      currentItemSeason: currentItemSeason,
    }));
  };

  const onSelect = (item) => {
    console.log("onSelect called", item);
    let isEpisode = false;
    if (item.season_id) {
      isEpisode = true;
    }
     const plans =
    typeof item.plans === "string"
      ? item.plans.split(",").map(Number)
      : typeof item.plans === "number"
        ? [item.plans]
        : item.plans;

  const owned =
    typeof item.owned_by === "string"
      ? item.owned_by.split(",").map(Number)
      : typeof item.owned_by === "number"
        ? [item.owned_by]
        : [];

  window.PLANSARRAY = plans;
  window.OWNED_BY = owned;
  window.IS_PAID = item.is_paid;
   function hasSingleMatch(arr1, arr2) {
  return arr1.some(v => arr2.includes(v));
}
 
 
  function arraysEquals(a, b) {
    console.log("arraysEquals called", a, b);

    // Check if both are arrays
    if (!Array.isArray(a) || !Array.isArray(b)) return false;

    // Check if lengths match
    if (a.length !== b.length) return false;

    // Check each element
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }

    // All elements matched
    return true;
  }
  let userDetails = JSON.parse(localStorage.getItem("user_details"));

 const subscriptionsArray =
    userDetails?.user_profiles?.[0]?.subscriptions || [];
  const subscriptionCheck =
    // banneritems[currentIndex].plans !== null
    item === null
    ? hasSingleMatch(owned, subscriptionsArray)
      : arraysEquals(window.PLANSIDS, plans);
      console.log("subscriptionCheck", subscriptionCheck,item,userDetails,data);
    if(data.is_paid==1&&!window.SUBSCRIPTIONDATA && isEpisode){
        handleErr("SUBSCRIBE-MESSAGE");
        return;
    }

    if (item?.type === 1 || item?.media_type === 1) {
      navigateToScreen("AudioPlayer", item);
    }

    if (isEpisode) {
      if (item?.type === 1 || item?.media_type === 1) {
        navigateToScreen("AudioPlayer", item);
      } else {
      getDRMLicense(item, itemDetails[0]);
      navigateToScreen("VideoScreen");
      updateNextEpisodeObject(itemDetails[0], item.season_id, item.id);
      }
    } else {
      if (typeof detailToDetail === "function") {
        console.log("detailToDetail Item ::", item);
        detailToDetail(item);
      } else {
        getDRMLicense(item, item);
        navigateToScreen("HomeDetailsScreen", item);
        sendSimilarThisEvent({item:item,itemDetails:itemDetails[0]});
      }
    }
  };

  const handleVideoBack = () => {
    navigateToScreen("HomeDetailsScreen");
    setScreen("HomeDetailsScreen");
    setShouldFocusToScreenBG(true);
  };

  const getDRMFileDetails = async (firstEpisode, data, drmData) => {
    console.log("getDRMFileDetails.....", firstEpisode, data, drmData);
    try {
      let mpdInfo = null;
      const requestOptions = {
        method: "POST",
        redirect: "follow",
      };
      const CDNDomain = drmData.file_url.split("/v1");
      [mpdInfo] = await Promise.all([fetch(drmData.file_url, requestOptions)]);
      // Check if the responses are okay
      if (!mpdInfo.ok) {
        throw new Error("mpd file POST failed");
      }
      const mpdData = await mpdInfo.json();
      itmDetails = [data];
      console.log("itmDetails 1", itmDetails)
      if (mountedRef.current) {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          //itemDetails:[SeriesDetails.data]
          itemDetails: [data],
          DRMToken: drmData.token,
          typ: "mpd",
          DRMvdoSRC: CDNDomain[0] + mpdData.manifestUrl,
        }));
      }
    } catch (error) {
      console.log("DRMFILES ERROR 1", error)
      if (mountedRef.current) {
        setState((prevState) => ({
          ...prevState,
          loading: false,
          itemDetails: [data],
          shouldFocusToScreenBG: true,
          shouldShowToast: false,
          toastMsg: "Playback URL error! Please try again later.",
          toastBgColor: "red",
        }));
      }
    }
  };

  const getDRMLicense = async (firstEpisode, data) => {

    if (!data) {
      return;
    }

    if (data.owned_by !== 0) {
      return;
    }

    if (
      data !== undefined &&
      data.owned_by !== undefined &&
      data.owned_by == 0
    ) {
      try {
        let drmInfo = null;

        const postBody = {
          vdc_id: firstEpisode.vdc_id,
          media_id: firstEpisode.video_id
            ? firstEpisode.video_id
            : firstEpisode.id,
        };

        const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";

        drmInfo = await createDrmLicenseV2(isSubscribe, postBody);

        getDRMFileDetails(firstEpisode, data, drmInfo.data);

        if (mountedRef.current) {
          setState((prevState) => ({
            ...prevState,
            DrmInformatin: drmInfo,
            GetVideoUrlData: drmInfo,
          }));
        }
      } catch (error) {
        if (mountedRef.current) {
          setState((prevState) => ({
            ...prevState,
            loading: false,
            itemDetails: [data],
            shouldShowToast: false,
            toastMsg: "Playback error! Please try again later.",
            toastBgColor: "red",
          }));
        }
      }
    }
  };

  function calculateAge(dobString) {
    if (!dobString) return null;
    const today = new Date();
    const dob = new Date(dobString);
    let age = today.getFullYear() - dob.getFullYear();
    const monthDiff = today.getMonth() - dob.getMonth();

    // adjust if birthday hasn't happened yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  }
const loadData = async () => {
    const userDetails = JSON.parse(localStorage.getItem("user_details") || "{}");

    const age = userDetails?.dob
    ? calculateAge(userDetails.dob)
    : "Not Available";

  const ages = age == "Not Available" ? 100 : age;

    if (hasFetchedDataRef.current) return;

    hasFetchedDataRef.current = true;

    if (!isGridCalledRef.current) return;
 
    const userId = localStorage.getItem("profileId");
 
    let partnerheaders = {

      publisher_id: `${data?.owned_by}`,

      event: "false",

      tag: "0",

    };
 
    const platform = 0;
 
    try {

      const [fetchedItemDetails, fetchVideoUrl] = await Promise.all([
 
        await getContentDetails(data.show_id ? data.show_id : data.id, platform),
 
        // Fetch video URL

        (async () => {
 
          const videoID =

            data?.video_id ||

            data?.show_id ||

            (await getContentDetails(data.video_id ? data.show_id : data.id, platform))

              ?.data?.season?.[0]?.videos?.[0]?.id;
 
          if (!videoID) {

            return null;

          }
 
          console.log("videoid", videoID, data, data.owned_by);
 
          let videoUrlResponse = null;

          const body = {

            contentId: data?.contentId,

          };
 
          // const jsonBody = JSON.stringify(body);

          const isSubscribe = window.IS_DISPLAY == '0' ? "true" : "false";
 
          if (data.owned_by == 0) {

            videoUrlResponse = await getVideoUrlV2(

              videoID,

              userId,

              isSubscribe

            );

          } else if (data.owned_by == undefined || data.owned_by > 0) {
            let publisherId = data?.owned_by !== undefined ? data?.owned_by : 17
            videoUrlResponse = await getContentPlaybackInfo(

              publisherId,

              body,

              partnerheaders

            );

          }

          if (videoUrlResponse.data) {

            if (mountedRef.current) {
              setState((prevState) => ({
                ...prevState,
                VideoDataDrm: videoUrlResponse.data,
              }));
            }

            videodataResponse2 = videoUrlResponse;

          }

          return videoUrlResponse;

        })(),

      ]);
 
      if (fetchedItemDetails.statusCode == 404) {

        // isError = true;

        if (mountedRef.current) {
          setState((prevState) => ({
            ...prevState,
            isError: true,
            loading: false,
          }));
        }

      }

      if (fetchedItemDetails.data !== undefined) {

        if (

          fetchedItemDetails.data.season !== undefined &&

          fetchedItemDetails.data.season.length > 0 &&

          fetchedItemDetails.data.season[0].videos !== undefined &&

          fetchedItemDetails.data.season[0].videos.length > 0 &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==

          undefined &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 1

        ) {

          if (data.owned_by == undefined || data.owned_by == 0)

            getDRMLicense(

              fetchedItemDetails.data.season[0].videos[0],

              fetchedItemDetails.data

            );

          //STATE FOR DRM_CONTENT

          if (mountedRef.current) {
            setState((prevState) => ({
              ...prevState,
              loading: false,
              itemDetails: [fetchedItemDetails.data],
              GetVideoUrlData: [fetchVideoUrl?.data],
            }));
          }


        } else if (

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected !==

          undefined &&

          fetchedItemDetails.data.season[0].videos[0].is_drm_protected === 0

        ) {

          //STATE FOR NON_DRM_CONTENT

          setState((prevState) => ({

            ...prevState,

            loading: false,

            itemDetails: [fetchedItemDetails.data],

            GetVideoUrlData: [fetchVideoUrl?.data],

          }));

        }

      } else {

        setNoDataFound(true);
        setState((prevState) => ({

          ...prevState,

          isError: true,

          loading: false,

          shouldShowToast: false,

          toastMsg: "Playback error! Please try again later.",

          toastBgColor: "red",

        }));

      }

      // Matomo Event for Content Detail Page View
      sendMatomo("ContentDetailPage", fetchedItemDetails.data,data,sourceContext);
 
      if (firstTag === "Radio") {

        // LiveRadio-Selected-contentid/contentName event
        await sendMatomo("LiveRadio", fetchedItemDetails.data,data);

      } else if (firstTag === "TV") {

        // liveChannel event
        await sendMatomo("LiveChannel", fetchedItemDetails.data,data);

      }

      // }

      isGridCalledRef.current = false;

    } catch (error) {

      setState((prevState) => ({

        ...prevState,

        loading: false,

        shouldShowToast: false,

        toastMsg: "Playback error! Please try again later.",

        toastBgColor: "red",

      }));

      isGridCalledRef.current = false;

    }

  };

  useEffect(() => {
    loadData();
    return () => { 
      mountedRef.current = false; 
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      dataWrapper = [];
      itmDetails = [];
      videodataResponse2 = null;
    };
  }, []);

  useEffect(() => {
    if (GetVideoUrlData && GetVideoUrlData[0]) {
      if (mountedRef.current) {
        setState((prevState) => ({
          ...prevState,
          GetVideoUrlData_audio: GetVideoUrlData,
        }));
      }
    }

    if (itemDetails && itemDetails.length > 0) {
      const sPrice = Number(itemDetails[0]?.pricing?.s_price || 0);
      const gstAmount = Number(itemDetails[0]?.pricing?.gst_amount || 0);
      if (mountedRef.current) {
        setPlansPrice(sPrice + gstAmount);
      }
    }
  }, [GetVideoUrlData, plansPrice, itemDetails]);

  const styles = {
    detailsContainer: {
      display: "flex",
      flexDirection: "column",
      background: "#000000",
      width: "100vw",
      height: "100vh",
      backgroundSize: "cover",
      backgroundPosition: "center", // Center the background image
      backgroundRepeat: "no-repeat", // Do not repeat the background image
    },
  };

  const handleError = (error) => {
    navigateToScreen("HomeDetailsScreen");
    setState((prevState) => ({
      ...prevState,
      shouldShowToast: true,
      toastMsg: "Playback error! Please try again later.",
      toastBgColor: "red",
      shouldFocusToScreenBG: true,
    }));
    timeoutRef.current = setTimeout(function () {
      if (mountedRef.current) {
        setState((prevState) => ({
          ...prevState,
          shouldShowToast: false,
          toastMsg: "",
          toastBgColor: "transparent",
        }));
      }
    }, 2000);
  };

  const getItemDetails = () => {
    return itmDetails;
  };

  if (screen === "HomeDetailsScreen") {
    ScreenComponent = (
      <HomeScreenBGItemScreen
         dataItem={data}
        banneritems={NoDataFound ? [{}] : dataWrapper}
        callBack={callBack}
        animation={false}
        navigate={navigateToScreen}
        isDetails={true}
        isError={isError}
        shouldFocusToScreenBG={shouldFocusToScreenBG}
        isLogedIn={isLogedIn}
        itemDetails={itemDetails}
        handleErr={handleErr}
        onSelect={onSelect}
        isLiveEvent={isLiveEvent}
        getItemDetails={getItemDetails}
        isLiveScreen={isLiveScreen}
        shouldShowAuthModal={shouldShowAuthModal}
        shouldRemindPopup={shouldRemindPopup}
        shouldAuthError={shouldAuthError}
        VideoDataDrm={VideoDataDrm}   
        shouldRental={shouldRental}
      />
    );
  } else if (screen === "VideoScreen") {
    ScreenComponent = (
      <VideoPlayer
        VideoDataDrm={VideoDataDrm}
        itemDetails={itemDetails}
        hasNextContent={hasNextContent}
        nextAvailableContent={episode}
        currentItemSeason={currentItemSeason}
        onSelect={onSelect}
        videoSrc={
          DRMvdoSRC !== null
            ? DRMvdoSRC
            : itemDetails !== undefined &&
              itemDetails[0] !== undefined &&
              itemDetails[0].file_url !== undefined &&
              itemDetails[0].file_url !== ""
              ? itemDetails[0].file_url
              : ""
        }
        type={typ}
        controlsColor="transparent"
        controlBarHeight="50px"
        progressBarColor="#EC008C"
        fullScreen={true}
        itemData={data}
        DrmInformatin={DrmInformatin}
        GetVideoUrlData={GetVideoUrlData}
        onError={handleError}
        onBack={handleVideoBack}
        isLive={isLiveScreen}
        DRMToken={DRMToken}
        
      />
    );
  } 
 else if (screen === "AudioPlayer") {
    ScreenComponent = (
      <AudioPlayer
        videoSrc={
          DRMvdoSRC !== null
            ? DRMvdoSRC
            : itemDetails !== undefined &&
              itemDetails[0] !== undefined &&
              itemDetails[0].file_url !== undefined &&
              itemDetails[0].file_url !== ""
              ? itemDetails[0].file_url
              : ""
        } 
        type={typ}
        backgroundImage={
          data.detail_banner
            ? data.detail_banner
            : data.banner_url
              ? data.banner_url
              : data.poster_url ?? data.poster_url
        }
        controlsColor="transparent"
        controlBarHeight="50px"
        progressBarColor="#EC008C"
        fullScreen={true}
        itemData={updateData}
        DrmInformatin={DrmInformatin}
        trackData={itemDetails?.[0]?.season?.[0]?.videos}
        itemDetails={itemDetails}
        GetVideoUrlData={GetVideoUrlData_audio}
        // GetVideoUrlData={GetVideoUrlData}
        onError={handleError}
        onBack={handleVideoBack}
        isLive={false}
        DRMToken={DRMToken}
      />
    );
  }

  return (
    <div style={styles.detailsContainer}>
      {loading && <LoaderScreen />}

      {ScreenComponent}
      {(shouldShowError || shouldRemindPopup || shouldRental) && (
      <ModalScreen
        shouldRental={shouldRental}
        premiumQr={premiumQr}
        shouldShowError={shouldShowError}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        okaybtn={okaybtn}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        data={data}
        shouldRemindPopup={shouldRemindPopup}
        remindPopup={remindPopup}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
      />
      )}
      {errorIcon && (
      <ErrorScreen errorIcon={errorIcon} disply={isError ? "flex" : "none"} bgcolor="#0E1653" homepage={true} />
      )}
      {(shouldShowAuthModal || shouldRental) && (
      <AuthFailModal
        shouldShowError={shouldShowAuthModal || shouldRental}
        errTitle={errTitle}
        errDescription={errDescription}
        errIcon={errIcon}
        button={button}
        iconWdth={iconWdth}
        iconHeight={iconHeight}
        modalOKButtonHandler={modalOKButtonHandler}
        modalCANCELButtonHandler={modalCANCELButtonHandler}
        premiumQr={premiumQr}
      />
      ) }
    </div>
  );
};

export default HomeDetailsScreen;